export const padNames = new Map([
    [36, 'Lábdob'],
    [37, 'Káva'],
    [40, 'Pergő'],
    [42, 'Zárt lábcin'],
    [44, 'Lábcin pedál'],
    [43, 'Álló tom'],
    [46, 'Nyitott lábcin'],
    [45, 'Középső Tom'],
    [49, 'Beütő'],
    [48, 'Felső Tom'],
    [51, 'Kísérő'],
    [53, 'Kísérő kupola'],
    [57, 'Beütő 2']
]);
//# sourceMappingURL=hu.js.map